export const LOGIN_MENU = {
  "title": "Login",
  "link": "#",
  "iconName": "login",
  "target": "_blank",
  "position": "right",
  "type": "prevent"
};
